/*微信登录鉴权*/
import { getWXAuth, userOauthLogin } from '@/api/wx'
import { getRequestSign } from 'lib/tools/platformSign'
import { setStorage, getStorage } from '@/utils/storage'
import { getRunningEnv } from 'lib/tools/getPlatform'

export default {
  data() {
    return {
      loginClass: {}
    }
  },
  created() {
    this.initLogin()
  },
  mounted() {
    // let userInfo = getStorage('live-userInfo') && JSON.parse(getStorage('live-userInfo'))
    // let code = this.$route.query.code
    // if (code && !userInfo) {
    //   this.handleLogin()
    // }
  },
  methods: {
    initLogin() {
      const { env } = getRunningEnv()
      const login = require('lib/login/login.js').default
      this.loginClass = login(env ? 'yida' : 'college', {
        wechatGetUserParams: {
          asyncLingXi: env ? false : true
        },
        hookGetWxAuthSuccess(data) {
          console.log('`hookGetWxAuthSuccess', data)
          if (data.nickname) {
            setStorage('live-wx-nickname', data.nickname)
          }
        }
      })
    },
    handleLogin() {
      // get-user-header没有微信昵称 在微信下有cookie但是没有登录，需要去授权一下拿
      return (window.$platform.isWechat && !getStorage('live-wx-nickname')
        ? this.loginClass.goLogin('manual')
        : this.loginClass.queryLoginStatus()
      )
        .then(() => {
          setStorage('live-userInfo', JSON.stringify(this.loginClass.userInfo))
          setStorage('live-userInfo-open_id', this.loginClass.userInfo.openId)
          console.log('loginSucceed', this.loginClass.userInfo)
        })
        .catch(() => {
          console.log('loginError')
        })
    },
    async handleWxAuth() {
      let code = this.$route.query.code
      if (Array.isArray(code)) {
        code = code[code.length - 1]
      }
      let redirect_url = window.location.href
      let wx_res = await getWXAuth({
        name: 'yixinlifw',
        code: code,
        auth_type: 'manual',
        redirect_url
      })
      // 302重定向授权
      if (+wx_res.code === 302) {
        window.location.href = wx_res.data.redirect_url
      }

      // 获取到open_id
      if (+wx_res.code === 0) {
        setStorage('live-userInfo-open_id', wx_res.data.open_id)
        let baseParams = {
          _platform: 'm',
          _version: '6.7.7',
          flag: 'weixin',
          open_id: wx_res.data.open_id,
          nickname: wx_res.data.nickname,
          union_id: wx_res.data.union_id
        }
        let platFormSign = getRequestSign(baseParams)
        let newParams = Object.assign(platFormSign.params, {
          sign: platFormSign.sign
        })
        // app授权登录
        let res = await userOauthLogin(newParams)

        if (+res.code === 0) {
          setStorage('live-userInfo', JSON.stringify(res))
        }
      }
    },
    handlewxLogin() {
      this.handleLogin()
    }
  }
}
